'use client';
import * as React from 'react';

// ThemeRegistry is no longer needed with Tailwind CSS
// Dark mode is handled via Tailwind's dark: classes and next-themes
export default function ThemeRegistry({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
